import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {Actions, createEffect,  ofType} from '@ngrx/effects';
import { select, Store} from '@ngrx/store';
import {switchMap, withLatestFrom} from 'rxjs/internal/operators';
import {map} from 'rxjs/operators';
import {debug} from '../../../rxjs-operators';
import {
  currentSubscriptionActionTypes,
  LoadCurrentSubscriptionAction,
  LoadCurrentSubscriptionFailAction,
  LoadCurrentSubscriptionSuccessAction} from '../actions/current-subscription';
import {error} from '../actions/toasts';
import {SubscriptionI} from '../models/subscription-i';
import {BaseEffect} from './base.effect';
import * as fromShared from '../reducers';
import {of} from 'rxjs';
import {L10nTranslationService} from 'angular-l10n';

@Injectable()
export class CurrentSubscriptionEffect extends BaseEffect {


  load$ = createEffect(() => { return this.actions$.pipe(ofType(currentSubscriptionActionTypes.LOAD),
    map( (action: LoadCurrentSubscriptionAction) => action.payload),
    debug('Load current subscription info action received.'),
    withLatestFrom(this.store.pipe(select(fromShared.selectors.getMySubscriptions))),
    switchMap(([payload, subscriptions]) => of(subscriptions.find(subscription => subscription.name === payload)).pipe(
      map((subscription: SubscriptionI) => {
        if (subscription) {
          return new LoadCurrentSubscriptionSuccessAction(subscription)
        } else {
          return new LoadCurrentSubscriptionFailAction()
        }
      })
    )))
  });


  loadFail$ = createEffect(() => { return this.actions$
    .pipe(ofType(currentSubscriptionActionTypes.LOAD_FAIL),
      debug('A error occurred while loading the current subscription.'),
      map((action: LoadCurrentSubscriptionFailAction) =>
        error(this.translation.translate('CURRENT_SUBSCRIPTION_LOAD_ERROR') + '  ' + action.payload,
          this.translation.translate('TOAST_ERROR_TITLE'))))
  });

  constructor(private actions$: Actions,
              private translation: L10nTranslationService,
              router: Router,
              private store: Store<fromShared.AppState>) {
    super(router);
  }

  protected handleUnhandledError = (response) => {
    return new LoadCurrentSubscriptionFailAction(response['error'].message);
  }

  protected handleGoneError = (response) => {
    return new LoadCurrentSubscriptionFailAction(response['error'].message);
  }
}
